import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleShowInfoUser } from '../../sidebar/reducer';
import { compose } from 'redux';

class AccountInfo extends Component {
  loadInfoUser = () => {
    const { toggleShowInfoUser } = this.props;
    toggleShowInfoUser();
  };

  render() {
    return (
      <div
        className="fiidropdown right account-info ml-6"
        onClick={this.loadInfoUser}
      >
        <a href="#">
          <span className="bg-bor-sp">
            <i className="icon-user1" />
            <span className="notifi-dot" />
          </span>
        </a>
      </div>
    );
  }
}

const mapDispatchToProps = {
  toggleShowInfoUser,
};

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),
)(AccountInfo);
